<h2 mat-dialog-title>
  {{ "incident.dialog.title" | translate }}
</h2>
@if (allIncidents?.length) {
  <div>
    <mat-dialog-content>
      <app-manager-list
        class="list-element"
        (selectElement)="selectIncident($event)"
        (changeFilter)="changeFilterIncident($event)"
        (changePage)="changePageIncident($event)"
        [displayObjects]="incidents"
        [maxItems]="numberOfAllIncident"
        [properties]="incidentProperties"
        [hasPaginatorPanel]="false"
      ></app-manager-list>
    </mat-dialog-content>
    <mat-dialog-actions class="incident-dialog-buttons">
      <app-button
        (clicked)="onClose()"
        class="incident-dialog-button"
        [labelPath]="'misc.cancel'"
      ></app-button>
      <app-button
        (clicked)="onApply()"
        class="incident-dialog-button"
        [type]="'filled'"
        [labelPath]="!isNewIncident ? 'misc.apply' : 'misc.new'"
      ></app-button>
    </mat-dialog-actions>
  </div>
}

@if (!allIncidents?.length) {
  <div class="incident-dialog-empty">
    @if (incidentsFetched) {
      <p>{{ "misc.empty" | translate }}</p>
    }
    @if (!incidentsFetched) {
      <mat-spinner [diameter]="16"></mat-spinner>
    }
    <mat-dialog-actions class="incident-dialog-buttons">
      <app-button
        (clicked)="onClose()"
        class="incident-dialog-button"
        [labelPath]="'misc.cancel'"
      ></app-button>
    </mat-dialog-actions>
  </div>
}
